import { useTranslation } from 'react-i18next';
import Modal from '../modal/modal';
import classNames from 'classnames';

export interface ConfirmationModalProps {
  text: string;
  confirmButtonText?: string;
  confirmButtonColorClasses?: string;
  warningText?: string;
  open: boolean;
  setOpen: (open: boolean) => void;
  onConfirm?: () => void;
  onCancel?: () => void;
}

export function ConfirmationModal({
  text,
  confirmButtonText,
  confirmButtonColorClasses,
  warningText,
  open,
  setOpen,
  onConfirm,
  onCancel,
}: ConfirmationModalProps) {
  const { t } = useTranslation(['common']);
  return (
    <Modal open={open} setOpen={setOpen} panelClassName="max-w-xl">
      <h1 className="text-lg">{text}</h1>
      {warningText && (
        <p className="text-lg text-semantic-error">{warningText}</p>
      )}
      <div className="flex justify-end mt-5">
        <button
          className="px-4 py-2 mr-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          onClick={() => {
            setOpen(false);
            onCancel?.();
          }}
        >
          {t('Cancel')}
        </button>
        <button
          className={classNames(
            'px-4 py-2 text-sm font-medium text-white border border-transparent rounded-md shadow-sm  focus:outline-none focus:ring-2 focus:ring-offset-2',
            confirmButtonColorClasses
              ? confirmButtonColorClasses
              : 'bg-red-500 focus:ring-red-500 hover:bg-red-600'
          )}
          onClick={() => {
            setOpen(false);
            onConfirm?.();
          }}
        >
          {confirmButtonText ? confirmButtonText : t('Confirm')}
        </button>
      </div>
    </Modal>
  );
}

export default ConfirmationModal;
